(function () {
  const DESIGN_IMAGES = {
    heartCutout:
      'https://cdn.shopify.com/s/files/1/0558/7386/3779/files/puzzlepieceheart_icon_dd3a062e-2bbe-41d9-8780-6ebc3e7def07.jpg?v=1758307036',
    puzzlePiece:
      'https://cdn.shopify.com/s/files/1/0558/7386/3779/files/puzzlepiece_icon_f7afdd4b-5ef5-4f48-a486-b2b62dec7625.jpg?v=1758306969',
  };

  const ROLE_CONFIG = {
    mom: {
      label: 'Mom',
      sizeGroup: 'adult',
      styles: ['hoodie', 'crewneck'],
      defaultStyle: 'crewneck',
      iconLabel: 'Heart with puzzle cutout',
      imageUrl: DESIGN_IMAGES.heartCutout,
      textKey: 'sleeveText',
      textLabel: 'Sleeve text above cuff',
      textMaxLength: 16,
      textPlaceholder: '(e.g. "The Heart")',
      productKey: {
        hoodie: 'adultHoodie',
        crewneck: 'adultCrewneck',
      },
    },
    dad: {
      label: 'Dad',
      sizeGroup: 'adult',
      styles: ['hoodie', 'crewneck'],
      defaultStyle: 'crewneck',
      iconLabel: 'Puzzle piece',
      imageUrl: DESIGN_IMAGES.puzzlePiece,
      textKey: 'sleeveText',
      textLabel: 'Sleeve text above cuff',
      textMaxLength: 16,
      textPlaceholder: '(e.g. "The Piece")',
      productKey: {
        hoodie: 'adultHoodie',
        crewneck: 'adultCrewneck',
      },
    },
    youth: {
      label: 'Youth',
      sizeGroup: 'youth',
      styles: ['crewneck'],
      defaultStyle: 'crewneck',
      iconLabel: 'Puzzle piece',
      imageUrl: DESIGN_IMAGES.puzzlePiece,
      textKey: 'chestText',
      textLabel: 'Text under puzzle piece',
      textMaxLength: 20,
      textPlaceholder: '(e.g. "The Princess")',
      productKey: {
        crewneck: 'youthCrewneck',
      },
    },
    toddler: {
      label: 'Toddler',
      sizeGroup: 'toddler',
      styles: ['crewneck'],
      defaultStyle: 'crewneck',
      iconLabel: 'Puzzle piece',
      imageUrl: DESIGN_IMAGES.puzzlePiece,
      textKey: 'chestText',
      textLabel: 'Text under puzzle piece',
      textMaxLength: 20,
      textPlaceholder: '(e.g. "The Night Owl")',
      productKey: {
        crewneck: 'toddlerCrewneck',
      },
    },
    baby: {
      label: 'Baby',
      sizeGroup: 'baby',
      styles: ['fleece'],
      defaultStyle: 'fleece',
      iconLabel: 'Puzzle piece',
      imageUrl: DESIGN_IMAGES.puzzlePiece,
      textKey: 'chestText',
      textLabel: 'Text under puzzle piece',
      textMaxLength: 20,
      textPlaceholder: '(e.g. "The Cuddle Bug")',
      productKey: {
        fleece: 'babyFleece',
      },
    },
  };

  const SIZE_OPTIONS = {
    adult: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
    youth: ['YS', 'YM', 'YL', 'YXL'],
    toddler: ['2T', '3T', '4T', '5/6T'],
    baby: ['NB', '6M', '12M', '18M'],
  };

  const ROLE_LIMITS = {
    mom: 1,
    dad: 1,
    youth: Infinity,
    toddler: Infinity,
    baby: Infinity,
  };

  const CLASS_HIDDEN = 'hidden';
  const productCache = new Map();
  const productRequests = new Map();

  function init() {
    document.querySelectorAll('[data-family-bundle-builder]').forEach((root) => {
      if (root.dataset.familyBundleReady === 'true') return;
      root.dataset.familyBundleReady = 'true';
      createBundleBuilder(root);
    });
  }

  function createBundleBuilder(root) {
    const sectionId = root.dataset.sectionId;
    const configNode = document.getElementById(`FamilyBundleConfig-${sectionId}`);
    if (!configNode) return;

    let config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      console.error('Invalid family bundle config', error);
      return;
    }

    const state = {
      config,
      selectedPaletteId: null,
      members: [],
      isSubmitting: false,
      notice: '',
    };

    const refs = {
      paletteGrid: root.querySelector('[data-family-bundle-palettes]'),
      paletteCurrent: root.querySelector('[data-family-bundle-palette-current]'),
      roleActions: root.querySelector('[data-family-bundle-role-actions]'),
      members: root.querySelector('[data-family-bundle-members]'),
      summary: root.querySelector('[data-family-bundle-summary]'),
      summaryPanel: root.querySelector('[data-family-bundle-summary-panel]'),
      notice: root.querySelector('[data-family-bundle-notice]'),
      submit: root.querySelector('[data-family-bundle-submit]'),
    };

    state.palettes = [...(config.palettes || [])]
      .filter((palette) => Boolean(palette.title))
      .sort((left, right) => (left.sortOrder || 999) - (right.sortOrder || 999));

    if (state.palettes.length > 0) {
      state.selectedPaletteId = state.palettes[0].id;
    }

    preloadProducts(config.linkedProducts);
    bindEvents(state, refs);
    render(state, refs);
  }

  function bindEvents(state, refs) {
    refs.paletteGrid.addEventListener('click', (event) => {
      const button = event.target.closest('[data-palette-id]');
      if (!button || button.disabled) return;

      const nextPaletteId = button.dataset.paletteId;
      if (!nextPaletteId || nextPaletteId === state.selectedPaletteId) return;

      const hadMembers = state.members.length > 0;
      state.selectedPaletteId = nextPaletteId;
      if (hadMembers) {
        state.notice = 'Palette updated for all family members.';
      }

      resolveAllMembers(state, refs);
      render(state, refs);
    });

    refs.roleActions.addEventListener('click', (event) => {
      const button = event.target.closest('[data-add-role]');
      if (!button || button.disabled) return;
      addMember(state, refs, button.dataset.addRole);
    });

    refs.members.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-member]');
      if (!removeButton) return;
      removeMember(state, refs, removeButton.dataset.removeMember);
    });

    refs.members.addEventListener('change', (event) => {
      const memberField = event.target.closest('[data-member-key]');
      if (!memberField) return;
      updateMember(
        state,
        refs,
        memberField.dataset.memberKey,
        event.target.dataset.fieldName || event.target.name,
        event.target.value
      );
    });

    refs.members.addEventListener('input', (event) => {
      const memberField = event.target.closest('[data-member-key]');
      if (!memberField || event.target.tagName !== 'INPUT' || event.target.type !== 'text') return;
      const sanitizedValue = sanitizeSingleLine(event.target.value);
      if (event.target.value !== sanitizedValue) {
        event.target.value = sanitizedValue;
      }
      const counter = memberField.querySelector('[data-text-count]');
      if (counter) {
        counter.textContent = `${sanitizedValue.length}/${event.target.maxLength || 0}`;
      }
      updateMember(
        state,
        refs,
        memberField.dataset.memberKey,
        event.target.dataset.fieldName || event.target.name,
        sanitizedValue,
        true
      );
    });

    refs.submit.addEventListener('click', async () => {
      if (!canSubmit(state)) return;

      state.isSubmitting = true;
      render(state, refs);

      try {
        await submitBundle(state);
        state.members = [];
        state.notice = '';
      } catch (error) {
        console.error(error);
        state.notice = error.message || 'Could not add this bundle to cart right now.';
      } finally {
        state.isSubmitting = false;
        render(state, refs);
      }
    });
  }

  function render(state, refs) {
    renderPaletteGrid(state, refs.paletteGrid, refs.paletteCurrent);
    renderRoleButtons(state, refs.roleActions);
    renderMembers(state, refs.members);
    renderSummary(state, refs.summary);
    renderNotice(state, refs.notice);
    if (refs.summaryPanel) {
      refs.summaryPanel.hidden = state.members.length === 0;
    }
    refs.submit.disabled = !canSubmit(state);
    refs.submit.textContent = state.isSubmitting ? 'Adding family set...' : 'Add Family Set to Cart';
  }

  function renderPaletteGrid(state, container, currentNode) {
    const disabled = !state.config.setupComplete || state.palettes.length === 0;
    const selectedPalette = getSelectedPalette(state);
    if (currentNode) {
      currentNode.innerHTML = `Palette: <span data-selected-value>${escapeHtml(
        selectedPalette ? selectedPalette.title : 'Choose a palette'
      )}</span>`;
    }
    container.innerHTML = state.palettes
      .map((palette) => {
        const selectedClass = palette.id === state.selectedPaletteId ? ' is-selected' : '';
        return `
          <button
            class="family-bundle-builder__palette${selectedClass}"
            type="button"
            data-palette-id="${escapeHtml(palette.id)}"
            aria-label="${escapeAttribute(palette.title)}"
            aria-pressed="${palette.id === state.selectedPaletteId ? 'true' : 'false'}"
            title="${escapeAttribute(palette.title)}"
            ${disabled ? 'disabled' : ''}
          >
            <span class="family-bundle-builder__palette-swatches" aria-hidden="true">
              <span
                class="family-bundle-builder__palette-swatch"
                style="--palette-primary:${escapeAttribute(palette.swatchPrimary)}; --palette-secondary:${escapeAttribute(palette.swatchSecondary)};"
              ></span>
            </span>
            <span class="visually-hidden">${escapeHtml(palette.title)}</span>
          </button>
        `;
      })
      .join('');
  }

  function renderRoleButtons(state, container) {
    const totalCount = state.members.length;
    const remainingPieces = Math.max(state.config.maxMembers - totalCount, 0);
    const buttons = Object.entries(ROLE_CONFIG).map(([role, roleConfig]) => {
      const count = getRoleCount(state.members, role);
      const maxed = count >= ROLE_LIMITS[role] || totalCount >= state.config.maxMembers;
      const disabled = !state.selectedPaletteId || !state.config.setupComplete || maxed || state.isSubmitting;
      const metaText = `${count} added (max ${remainingPieces} piece${remainingPieces === 1 ? '' : 's'})`;
      const displayMetaText = role === 'mom' || role === 'dad' ? `${count} of 1 added` : metaText;
      return `
        <button
          class="family-bundle-builder__role-button"
          type="button"
          data-add-role="${role}"
          ${disabled ? 'disabled' : ''}
        >
          <span class="family-bundle-builder__role-button-label">Add ${roleConfig.label} +</span>
          <span class="family-bundle-builder__role-button-meta">${escapeHtml(displayMetaText)}</span>
        </button>
      `;
    });

    const capNote =
      totalCount >= state.config.maxMembers
        ? `<p class="family-bundle-builder__helper">You have reached the ${state.config.maxMembers}-piece limit for one bundle.</p>`
        : '';

    container.innerHTML = `${buttons.join('')}${capNote}`;
  }

  function renderMembers(state, container) {
    if (state.members.length === 0) {
      container.innerHTML = `
        <div class="family-bundle-builder__empty">
          Start with Mom, Dad, or any child piece. The selected palette will carry across every item you add.
        </div>
      `;
      return;
    }

    container.innerHTML = state.members
      .map((member, index) => {
        const roleConfig = ROLE_CONFIG[member.role];
        const styleOptions = roleConfig.styles.map((style) => ({
          value: style,
          label: humanizeStyle(style),
        }));
        const displayName = getDisplayName(state.members, member, index);
        const palette = getSelectedPalette(state);
        const paletteLabel = palette ? palette.title : 'Choose a palette';
        const textValue = member[roleConfig.textKey] || '';
        const statusMarkup = member.error
          ? `<div class="family-bundle-builder__card-error">${escapeHtml(member.error)}</div>`
          : '';
        const previewMarkup = renderMemberPreviews(roleConfig, palette, paletteLabel);
        const styleMarkup = renderPillField({
          memberKey: member.key,
          fieldName: 'style',
          label: 'Garment style',
          options: styleOptions,
          selectedValue: member.style,
          singleOption: roleConfig.styles.length === 1,
        });
        const sizeMarkup = renderPillField({
          memberKey: member.key,
          fieldName: 'size',
          label: 'Size',
          options: SIZE_OPTIONS[roleConfig.sizeGroup].map((size) => ({ value: size, label: size })),
          selectedValue: member.size,
          fullWidth: true,
        });

        return `
          <article class="family-bundle-builder__member" data-member-key="${member.key}">
            <div class="family-bundle-builder__member-head">
              <div>
                <h4 class="family-bundle-builder__member-title">${escapeHtml(displayName)}</h4>
                <div class="family-bundle-builder__member-badges">
                  ${previewMarkup}
                </div>
              </div>
              <button class="family-bundle-builder__member-remove" type="button" data-remove-member="${member.key}">
                Remove
              </button>
            </div>
            <div class="family-bundle-builder__member-grid">
              ${styleMarkup}
              ${sizeMarkup}
              <div class="family-bundle-builder__field is-full">
                <label class="form__label" for="family-text-${member.key}">${escapeHtml(roleConfig.textLabel)}</label>
                <div class="family-bundle-builder__text-input-wrap">
                  <input
                    id="family-text-${member.key}"
                    name="${roleConfig.textKey}"
                    type="text"
                    class="family-bundle-builder__text-input"
                    maxlength="${roleConfig.textMaxLength}"
                    placeholder="${escapeAttribute(roleConfig.textPlaceholder)}"
                    value="${escapeAttribute(textValue)}"
                  >
                  <span class="family-bundle-builder__text-count" data-text-count>${textValue.length}/${roleConfig.textMaxLength}</span>
                </div>
              </div>
            </div>
            ${statusMarkup}
          </article>
        `;
      })
      .join('');
  }

  function renderSummary(state, container) {
    if (state.members.length === 0) {
      container.innerHTML = `
        <div class="family-bundle-builder__summary-empty">
          Your summary will update here as you add each family member.
        </div>
      `;
      return;
    }

    const subtotal = state.members.reduce((sum, member) => sum + (member.price || 0), 0);
    const itemsMarkup = state.members
      .map((member, index) => {
        const displayName = getDisplayName(state.members, member, index);
        const detailLines = [
          `Style: ${humanizeStyle(member.style)}`,
          `Size: ${member.size || 'Select size'}`,
        ];
        const textValue = member.sleeveText || member.chestText;
        if (textValue) detailLines.push(`Text: ${textValue}`);
        const detailMarkup = detailLines
          .map((line) => `<div class="family-bundle-builder__summary-detail">${escapeHtml(line)}</div>`)
          .join('');

        return `
          <div class="family-bundle-builder__summary-item">
            <div class="family-bundle-builder__summary-top">
              <span class="family-bundle-builder__summary-name">${escapeHtml(displayName)}</span>
              <span>${member.price != null ? escapeHtml(formatMoney(state, member.price)) : '--'}</span>
            </div>
            <div class="family-bundle-builder__summary-meta">${detailMarkup}</div>
          </div>
        `;
      })
      .join('');

    container.innerHTML = `
      <div class="family-bundle-builder__summary-list">${itemsMarkup}</div>
      <div class="family-bundle-builder__summary-row">
        <span>${state.members.length} piece${state.members.length === 1 ? '' : 's'}</span>
        <span class="family-bundle-builder__summary-total">${escapeHtml(formatMoney(state, subtotal))}</span>
      </div>
    `;
  }

  function renderNotice(state, node) {
    if (!state.notice) {
      node.classList.add(CLASS_HIDDEN);
      node.textContent = '';
      return;
    }

    node.classList.remove(CLASS_HIDDEN);
    node.textContent = state.notice;
  }

  function renderPillField({ memberKey, fieldName, label, options, selectedValue, fullWidth = false, singleOption = false }) {
    const fieldClass = fullWidth ? ' is-full' : '';
    const selectedOption = options.find((option) => option.value === selectedValue);
    const selectedLabel = selectedOption ? selectedOption.label : '';
    const radios = options
      .map((option) => {
        const optionId = `family-${fieldName}-${memberKey}-${toHandle(option.value)}`;
        return `
          <input
            type="radio"
            id="${optionId}"
            name="${fieldName}-${memberKey}"
            data-field-name="${fieldName}"
            value="${escapeAttribute(option.value)}"
            ${selectedValue === option.value ? 'checked' : ''}
          >
          <label for="${optionId}">${escapeHtml(option.label)}</label>
        `;
      })
      .join('');

    return `
      <fieldset
        class="family-bundle-builder__field product-form__input product-form__input--pill${fieldClass}${
          singleOption ? ' family-bundle-builder__pill-single' : ''
        }"
        data-pill-field="${fieldName}"
      >
        <legend class="form__label">
          ${escapeHtml(label)}:
          <span data-selected-value>${escapeHtml(selectedLabel)}</span>
        </legend>
        ${radios}
      </fieldset>
    `;
  }

  function renderMemberPreviews(roleConfig, palette, paletteLabel) {
    return `
      <div class="family-bundle-builder__member-preview">
        <img
          class="family-bundle-builder__design-image"
          src="${escapeAttribute(roleConfig.imageUrl)}"
          alt="${escapeAttribute(roleConfig.iconLabel)}"
          loading="lazy"
        >
        <div class="family-bundle-builder__member-preview-copy">
          <span class="family-bundle-builder__member-preview-label">Embroidery design</span>
          <span class="family-bundle-builder__member-preview-value">${escapeHtml(roleConfig.iconLabel)}</span>
        </div>
      </div>
      <div class="family-bundle-builder__member-preview">
        <span class="family-bundle-builder__palette-swatches" aria-hidden="true">
          <span
            class="family-bundle-builder__palette-swatch family-bundle-builder__palette-swatch--small"
            style="--palette-primary:${escapeAttribute(palette ? palette.swatchPrimary : '#8c5466')}; --palette-secondary:${escapeAttribute(
              palette ? palette.swatchSecondary : '#c9ced6'
            )};"
          ></span>
        </span>
        <div class="family-bundle-builder__member-preview-copy">
          <span class="family-bundle-builder__member-preview-label">Palette</span>
          <span class="family-bundle-builder__member-preview-value">${escapeHtml(paletteLabel)}</span>
        </div>
      </div>
    `;
  }

  function addMember(state, refs, role) {
    if (!ROLE_CONFIG[role]) return;
    if (getRoleCount(state.members, role) >= ROLE_LIMITS[role]) return;
    if (state.members.length >= state.config.maxMembers) return;

    const roleConfig = ROLE_CONFIG[role];
    const member = {
      key: `${role}-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`,
      role,
      style: roleConfig.defaultStyle,
      size: SIZE_OPTIONS[roleConfig.sizeGroup][0] || '',
      sleeveText: '',
      chestText: '',
      resolvedColorName: '',
      productHandle: null,
      variantId: null,
      price: null,
      error: '',
      isResolving: false,
    };

    state.members = [...state.members, member];
    state.notice = '';
    resolveAllMembers(state, refs, member.key);
  }

  function removeMember(state, refs, memberKey) {
    state.members = state.members.filter((member) => member.key !== memberKey);
    state.notice = '';
    render(state, refs);
  }

  function updateMember(state, refs, memberKey, fieldName, fieldValue, isInput) {
    let requiresResolve = false;
    state.members = state.members.map((member) => {
      if (member.key !== memberKey) return member;

      const nextMember = { ...member };
      const value = isInput ? sanitizeSingleLine(fieldValue) : fieldValue;
      nextMember[fieldName] = value;
      nextMember.error = '';

      if (fieldName === 'style' || fieldName === 'size') {
        requiresResolve = true;
      }

      if (fieldName === 'sleeveText' || fieldName === 'chestText') {
        nextMember[fieldName] = value.slice(0, ROLE_CONFIG[member.role].textMaxLength);
      }

      return nextMember;
    });

    if (requiresResolve) {
      resolveAllMembers(state, refs, memberKey);
      return;
    }

    renderSummary(state, refs.summary);
    renderNotice(state, refs.notice);
    refs.submit.disabled = !canSubmit(state);
    refs.submit.textContent = state.isSubmitting ? 'Adding family set...' : 'Add Family Set to Cart';
  }

  function resolveAllMembers(state, refs, specificKey) {
    const pending = state.members
      .filter((member) => !specificKey || member.key === specificKey)
      .map((member) => resolveMember(state, member.key));

    render(state, refs);
    Promise.all(pending)
      .catch((error) => console.error(error))
      .finally(() => render(state, refs));
  }

  async function resolveMember(state, memberKey) {
    const palette = getSelectedPalette(state);
    const memberIndex = state.members.findIndex((member) => member.key === memberKey);
    if (memberIndex === -1) return;

    const member = { ...state.members[memberIndex] };
    member.error = '';
    member.price = null;
    member.variantId = null;
    member.productHandle = null;
    member.resolvedColorName = '';

    if (!palette) {
      state.members[memberIndex] = member;
      return;
    }

    member.resolvedColorName = getColorForRole(member.role, palette);
    member.productHandle = getProductHandle(state.config.linkedProducts, member);

    if (!member.productHandle) {
      member.error = 'This bundle is missing a linked product for that garment.';
      state.members[memberIndex] = member;
      return;
    }

    if (!member.resolvedColorName) {
      member.error = `${palette.title} is missing a mapped color for ${ROLE_CONFIG[member.role].label}.`;
      state.members[memberIndex] = member;
      return;
    }

    if (!member.size) {
      state.members[memberIndex] = member;
      return;
    }

    member.isResolving = true;
    state.members[memberIndex] = member;

    try {
      const product = await fetchProduct(member.productHandle);
      const colorIndex = findOptionIndex(product, 'Color');
      const sizeIndex = findOptionIndex(product, 'Size');
      const requiresRole = member.role === 'mom' || member.role === 'dad';
      const roleIndex = requiresRole
        ? findOptionIndex(product, 'Family Member') || findOptionIndex(product, 'Role')
        : null;

      if (!colorIndex || !sizeIndex) {
        member.error = 'Linked product options must be named Color and Size.';
        return;
      }

      if (requiresRole && !roleIndex) {
        member.error = 'Adult linked products must include Family Member (or Role) with values Mom and Dad.';
        return;
      }

      const expectedRoleValue = requiresRole ? ROLE_CONFIG[member.role].label : '';

      const matchedVariant = product.variants.find((variant) => {
        const colorValue = variant[`option${colorIndex}`];
        const sizeValue = variant[`option${sizeIndex}`];
        const roleValue = requiresRole ? variant[`option${roleIndex}`] : '';
        const roleMatches = !requiresRole || roleValue === expectedRoleValue;
        return colorValue === member.resolvedColorName && sizeValue === member.size && roleMatches;
      });

      if (!matchedVariant) {
        member.error = requiresRole
          ? 'That palette, size, and role combination is not available for this garment.'
          : 'That palette and size combination is not available for this garment.';
        return;
      }

      if (!matchedVariant.available) {
        member.error = 'That garment is currently sold out in the selected size.';
        return;
      }

      member.variantId = matchedVariant.id;
      member.price = matchedVariant.price;
    } catch (error) {
      member.error = 'Could not load this garment right now.';
    } finally {
      member.isResolving = false;
      state.members[memberIndex] = member;
    }
  }

  async function submitBundle(state) {
    const palette = getSelectedPalette(state);
    if (!palette) throw new Error('Choose a palette before adding this bundle to cart.');

    const cartDrawer = document.querySelector('cart-drawer');
    const items = state.members.map((member, index) => {
      const properties = buildProperties(state, member, palette, index);
      return {
        id: member.variantId,
        quantity: 1,
        properties,
      };
    });

    const sectionsToRender = cartDrawer
      ? cartDrawer.getSectionsToRender().map((section) => section.id)
      : [];

    const cartAddUrl = `${window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add'}.js`;
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items,
        sections: sectionsToRender,
        sections_url: window.location.pathname,
      }),
    });

    const payload = await response.json();
    if (!response.ok) {
      throw new Error(payload.description || payload.message || 'Could not add the bundle to cart.');
    }

    if (!cartDrawer) {
      window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
      return;
    }

    const sections = await fetchCartSections(cartDrawer);
    cartDrawer.renderContents({
      id: items[0].id,
      sections,
    });
  }

  async function fetchCartSections(cartDrawer) {
    const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id);
    const responses = await Promise.all(
      sectionIds.map(async (sectionId) => {
        const sectionUrl = `${window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart'}?section_id=${encodeURIComponent(sectionId)}`;
        const response = await fetch(sectionUrl, {
          cache: 'no-store',
          headers: {
            Accept: 'text/html',
          },
        });

        if (!response.ok) {
          throw new Error(`Could not refresh section ${sectionId}.`);
        }

        return [sectionId, await response.text()];
      })
    );

    return Object.fromEntries(responses);
  }

  function buildProperties(state, member, palette, index) {
    const properties = {
      Palette: palette.title,
      'Garment Style': humanizeStyle(member.style),
      'Embroidery Icon': ROLE_CONFIG[member.role].iconLabel,
    };

    if (member.role !== 'mom' && member.role !== 'dad') {
      properties['Family Member'] = getDisplayName(state.members, member, index);
    }

    if (member.sleeveText) {
      properties['Sleeve Text'] = member.sleeveText.trim();
    }

    if (member.chestText) {
      properties['Chest Text'] = member.chestText.trim();
    }

    return properties;
  }

  function canSubmit(state) {
    if (!state.config.setupComplete || state.isSubmitting || state.members.length === 0 || !state.selectedPaletteId) {
      return false;
    }

    return state.members.every((member) => Boolean(member.size && member.variantId && !member.error && !member.isResolving));
  }

  function preloadProducts(linkedProducts) {
    Object.values(linkedProducts || {})
      .filter(Boolean)
      .forEach((handle) => {
        fetchProduct(handle).catch((error) => console.error(error));
      });
  }

  function fetchProduct(handle) {
    if (!handle) {
      return Promise.reject(new Error('Missing product handle.'));
    }

    if (productCache.has(handle)) {
      return Promise.resolve(productCache.get(handle));
    }

    if (productRequests.has(handle)) {
      return productRequests.get(handle);
    }

    const request = fetch(`/products/${handle}.js`, {
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Could not load product ${handle}.`);
        }
        return response.json();
      })
      .then((product) => {
        productCache.set(handle, product);
        return product;
      })
      .finally(() => {
        productRequests.delete(handle);
      });

    productRequests.set(handle, request);
    return request;
  }

  function findOptionIndex(product, optionName) {
    const index = product.options.findIndex((option) => {
      if (typeof option === 'string') {
        return option.toLowerCase() === optionName.toLowerCase();
      }

      if (option && typeof option.name === 'string') {
        return option.name.toLowerCase() === optionName.toLowerCase();
      }

      return false;
    });
    return index === -1 ? null : index + 1;
  }

  function getSelectedPalette(state) {
    return state.palettes.find((palette) => palette.id === state.selectedPaletteId) || null;
  }

  function getColorForRole(role, palette) {
    if (role === 'mom' || role === 'dad') return palette.adultColorName;
    if (role === 'youth') return palette.youthColorName;
    if (role === 'toddler') return palette.toddlerColorName;
    if (role === 'baby') return palette.babyColorName;
    return '';
  }

  function getProductHandle(linkedProducts, member) {
    const roleConfig = ROLE_CONFIG[member.role];
    const key = roleConfig.productKey[member.style];
    return linkedProducts[key] || '';
  }

  function getRoleCount(members, role) {
    return members.filter((member) => member.role === role).length;
  }

  function getDisplayName(members, targetMember, targetIndex) {
    const roleConfig = ROLE_CONFIG[targetMember.role];
    if (targetMember.role === 'mom' || targetMember.role === 'dad') return roleConfig.label;

    let count = 0;
    for (let index = 0; index <= targetIndex; index += 1) {
      if (members[index].role === targetMember.role) {
        count += 1;
      }
    }
    return `${roleConfig.label} ${count}`;
  }

  function sanitizeSingleLine(value) {
    return value.replace(/[\r\n]+/g, ' ');
  }

  function toHandle(value) {
    return String(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function humanizeStyle(style) {
    if (style === 'crewneck') return 'Crewneck';
    if (style === 'hoodie') return 'Hoodie';
    if (style === 'fleece') return 'Fleece Bodysuit';
    return style;
  }

  function formatMoney(state, cents) {
    return new Intl.NumberFormat(state.config.locale || document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: state.config.currencyCode || 'USD',
    }).format((cents || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
